import api from 'apis/restaurant-api/api';
import { RestaurantApiResults } from 'apis/restaurant-api/types';

import { User, UserAccessRight, SearchUser } from './types';

export const fetchMe = () => api.get<{ user: User }>('/v1/user/me').then(response => response.data.user);

export const fetchAccessRights = () =>
  api.get<{ results: UserAccessRight[] }>('/v2/merchant-admin/access').then(response => response.data.results);

export const claimToken = (token: string) => api.put(`/v1/merchant-admin/invites/${token}`);

export const searchUsers = (searchTerm: string) =>
  api
    .get<RestaurantApiResults<SearchUser>>('/v1/merchant-admin/users', {
      params: {
        q: searchTerm,
      },
    })
    .then(response => ({
      users: response.data.results,
      searchTerm,
    }));
